/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import TastingNotesPage from '../../../components/TastingNotesPage';

export default function TastingNote({ ...rest }) {
  return <TastingNotesPage locale="en" {...rest} />;
}
